/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  DefundTenantGuaranteeOptions,
  DefundTenantGuaranteeResponses,
} from '../types/DefundTenantGuarantee'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Creates a guarantee-fund ledger entry with tx_kind WITHDRAWAL.
 * @summary Deduct funds from the guarantee fund for a tenant.
 * {@link /v1/tenants/:tenant_id/defund_guarantee}
 */
export function defundTenantGuarantee<ThrowOnError extends boolean = true>(
  options: Options<DefundTenantGuaranteeOptions, ThrowOnError>,
): Unwrappable<RequestResult<DefundTenantGuaranteeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/tenants/{tenant_id}/defund_guarantee',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<DefundTenantGuaranteeResponses, ThrowOnError>>,
  )
}
